import { createSlice } from '@reduxjs/toolkit';
import {
  addWishlist,
  getWishlist,
  removeAllFromWishlist,
  removeFromWishlist,
} from '../thunk/wishlist-thunk';

const initialState = {
  items: [],
  loading: false,
  error: null,
  isInitiated: false,
};

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    addToWishlist: (state, action) => {
      const product = action.payload;

      const existingProductIndex = state.items.findIndex(
        (p) => p.id === product.id,
      );

      let updatedWishlist;

      if (existingProductIndex === -1) {
        updatedWishlist = [...state.items, { ...product }];
      }
      state.items = updatedWishlist;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addWishlist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addWishlist.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.isInitiated = false;
      })
      .addCase(addWishlist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getWishlist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getWishlist.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
        state.isInitiated = true;
      })
      .addCase(getWishlist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(removeFromWishlist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeFromWishlist.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.length >= 0) {
          state.items = action.payload;
          state.isInitiated = false;
        }
      })
      .addCase(removeFromWishlist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(removeAllFromWishlist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeAllFromWishlist.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
        state.isInitiated = false;
      })
      .addCase(removeAllFromWishlist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { addToWishlist } = wishlistSlice.actions;

export default wishlistSlice.reducer;
